import { Navigate, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useFetchUserBookingDetails } from '../hooks/useFetchUserBookingDeails';

/**
 * Restricts booking detail routes by role:
 * - "guest": only the booking customer (userID)
 * - "owner": only the studio owner (studioOwnerID)
 */
const BookingRoleRoute = ({ children, allowedRole }) => {
  const { id: bookingId } = useParams();
  const { user: currentUser } = useSelector((state) => state.auth || {});
  const currentUserId = currentUser?._id || currentUser?.id;
  const { bookingData, loading, error } = useFetchUserBookingDetails(bookingId);

  if (loading) {
    return null;
  }

  if (error || !bookingData || !currentUserId) {
    return <Navigate to="/error/403" replace />;
  }

  const isGuest = currentUserId === bookingData?.userID;
  const isOwner = currentUserId === bookingData?.studioOwnerID;

  if (allowedRole === 'guest' && !isGuest) {
    return <Navigate to="/error/403" replace />;
  }

  if (allowedRole === 'owner' && !isOwner) {
    return <Navigate to="/error/403" replace />;
  }

  return children;
};

export default BookingRoleRoute;
